import { toast } from "sonner";

/**
 * The one place the app raises a toast. Everything funnels through here (today that is
 * only the live "notification" events) so tests mock this module instead of sonner, and
 * a future filter or collapse policy has a single choke point.
 */
export function pushToast(message: string): void {
  toast(message);
}
